import { useCloudAuth } from './hooks/useCloudAuth';
import { useDeviceDiscovery } from './hooks/useDeviceDiscovery';
import { useRemoteAgent } from './hooks/useRemoteAgent';
import { AuthPage } from './pages/AuthPage';
import { DevicePicker } from './components/DevicePicker';
import { ChatView } from './components/ChatView';

export default function App() {
  const { user, loading: authLoading, login, register, logout, getToken } = useCloudAuth();
  const { devices, activeDevice, loading: devLoading, selectDevice, refresh } = useDeviceDiscovery(getToken);
  const { sendMessage, respondApproval } = useRemoteAgent(activeDevice, refresh);

  // Loading auth state
  if (authLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg)' }}>
        <div style={{ textAlign: 'center', color: 'var(--color-text-muted)' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🦞</div>
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  // Not logged in → auth page
  if (!user) {
    return <AuthPage onLogin={login} onRegister={register} />;
  }

  // Logged in but no active device → device picker
  if (!activeDevice) {
    return (
      <DevicePicker
        devices={devices}
        onSelect={selectDevice}
        onRefresh={refresh}
        onLogout={logout}
        loading={devLoading}
        username={user.username}
      />
    );
  }

  // Connected to a device → chat
  return (
    <ChatView
      device={activeDevice}
      sendMessage={sendMessage}
      respondApproval={respondApproval}
      onDisconnect={() => selectDevice(null as never)}
      username={user.username}
      onLogout={logout}
    />
  );
}
